module.exports = __webpack_public_path__ + "img/jeni-sandy-signature.d564debb.svg";